export default __webpack_public_path__ + "static/media/x.b5db5e30.svg";